// CardsGrid.jsx
import React from "react";
import Card from "./CardComponent";

// import images
import ufsImage from "../../../assets/ufs_newcard.jpg";
import aeroflyImage from "../../../assets/aerofly_newcard.jpg";
import khmersImage from "../../../assets/card_images/khermgate_card_image.jpg";
import brandpulseImage from "../../../assets/card_images/brand_pulse_card_image.jpg";

// import logos
import ufs_logo from "../../../assets/ufs_logo.svg";
import aerofly_logo from "../../../assets/aerofly_logo.svg";
import khmers_logo from "../../../assets/khmergate.png";
import brandpulse_logo from "../../../assets/brandpulse_logo.svg";

const cardsData = [
  {
    image: ufsImage,
    logo: ufs_logo,
    title: "UFS",
    description:
      "Delivering efficient and reliable logistics solutions to connect businesses across the globe",
  },
  {
    image: aeroflyImage,
    logo: aerofly_logo,
    title: "Aerofly Aviation",
    description:
      "Elevating aviation services with cutting-edge solutions for airlines worldwide",
  },
  {
    image: khmersImage,
    logo: khmers_logo,
    title: "Khmers Gate",
    description:
      "Creating unforgettable travel experiences that celebrate culture, adventure, and authenticity",
  },
  {
    image: brandpulseImage,
    logo: brandpulse_logo,
    title: "BrandPulse",
    description:
      "Empowering brands to inspire through innovative strategies and creative storytelling",
  },
];

const CardsGrid = () => {
  // ✅ Hide UFS card
  const filteredCards = cardsData.filter((card) => card.title !== "UFS");

  // ✅ Keep same visual balance (cards count based columns)
  const lgColsClass =
    filteredCards.length === 3 ? "lg:grid-cols-3" : "lg:grid-cols-4";

  return (
    <div className={`grid grid-cols-1 md:grid-cols-2 ${lgColsClass} gap-1 my-3 mx-10`}>
      {filteredCards.map((card, index) => (
        <Card
          key={index}
          image={card.image}
          logo={card.logo}
          title={card.title}
          description={card.description}
        />
      ))}
    </div>
  );
};

export default CardsGrid;